import { ReadonlyURLSearchParams } from 'next/navigation';

export const getPriceMax = (searchParams: ReadonlyURLSearchParams) => Number(searchParams.get('priceScopeEnd'));
